import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useChat } from "../../../context/chatContext";
import { adminReporting, useCases } from "../../../utils/constants";
import { UseCase } from "../../../utils/interfaces";
import ChatHeader from "../../common/chat/chatHeader";
import Footer from "../../common/footer";
import { handleOptionSelect } from "../../../utils/functions";

const AdminFeatures = () => {
	const navigate = useNavigate();
	const {
		selectedUseCase,
	} = useChat();

	const [isSelecting, setIsSelecting] = useState(false);

	const handleSelect = async (index: number) => {
		if (isSelecting) return;
		await handleOptionSelect(
		  adminReporting, 
		  index, 
		  navigate, 
		  isSelecting,
		  setIsSelecting,
		  () => console.log(adminReporting[0].value, adminReporting[0].route)
		);
	  };

	const handleSelectDropdown = async (index: number) => {
		if (isSelecting) return;
		setIsSelecting(true);
		if (index === useCases[0].value) {
			navigate(useCases[0].route);
		} else if (index === useCases[1].value) {
			navigate(useCases[1].route);
		} else if (index === useCases[2].value) {
			navigate(useCases[2].route);
		} else if (index === useCases[3].value) {
			navigate(useCases[3].route);
		} else if (index === useCases[10].value) {
			navigate(useCases[10].route);
		}
		setIsSelecting(false);
	};

	return (
		<>
			<ChatHeader
				useCase={selectedUseCase}
				selectUseCase={handleSelectDropdown}
			/>

			<main className="d-flex flex-column min-vh-65">
				<section className="homemain d-flex justify-content-center align-items-center mt-auto">
					<div className="container">
						<div className="row justify-content-center">
							<div className="col-md-10 mb-1">
								<h1 className="mb-md-5 mb-4 text-center text-blue">
									How can I help you today?
								</h1>
								<div className="row g-4">
									{adminReporting.map((useCase: UseCase, key) => (
										<div className="col" key={`case_cards_${key}`}>
											<div
												className="card h-100 d-flex flex-column"
												onClick={() => handleSelect(useCase?.value)}
												style={{ cursor: "pointer" }}
											>
												<div className="card-body d-flex flex-column">
													<div className="iconbox mb-3">{useCase?.sprite}</div>
													<div className="d-flex flex-column justify-content-center flex-grow-1">
														<h5 className="card-title mb-3">{useCase.name}</h5>
													</div>
													<div className="d-flex flex-column justify-content-end flex-grow-1">
														<p className="card-text text-secondary">
															{useCase.helpingText}
														</p>
													</div>
												</div>
											</div>
										</div>
									))}
								</div>
							</div>
						</div>
					</div>
				</section>
			</main>
			<Footer />
		</>
	);
};

export default AdminFeatures;
